export default {
  name: 'gwiazda',
  title: 'Narzędzie wielokąt/gwiazda',
  buttons: [
    {
      title: 'Narzędzie gwiazda'
    },
    {
      title: 'Narzędzie wielokąt'
    }
  ],
  contextTools: [
    {
      title: 'Liczba boków',
      label: 'punkty'
    },
    {
      title: 'Ostrość',
      label: 'Ostrość'
    },
    {
      title: 'Skręca gwiazdę',
      label: 'Przesunięcie radialne'
    },
    {
      title: 'Liczba boków',
      label: 'boki'
    }
  ]
}